var EB_QUOTA_ERROR = "totalProductQtyEBExceeded";

/**
 * Triggers the limitation modal if the response JSON indicates that the EB quota limit has been exceeded.
 * @param {object} responseJSON JSON response from the server
 * @param {object} options Options object that can contain an onShow callback function
 * @returns {boolean} Returns true if the limitation modal was shown, false otherwise
 */
function showLimitationModalIfNeeded(responseJSON, options) {
    var $limitationModal = $("#limitationModal");

    if (!$limitationModal.length || !responseJSON || responseJSON.errorMessage !== EB_QUOTA_ERROR) {
        return false;
    }

    if (options && typeof options.onShow === "function") {
        options.onShow();
    }

    $limitationModal.modal("show");
    return true;
}

module.exports = {
    showLimitationModalIfNeeded: showLimitationModalIfNeeded
};
